<template>
  <div>
    <section>
      <b-field label="Filter by user" horizontal>
        <b-select v-model="filterByUser">
          <option value="">
            All company transactions
          </option>
          <option v-for="user in companyUsers"
                  :key="user.accountKey"
                  :value="user.accountKey">
            {{ user.accountFirstName }} {{ user.accountLastName}}
            {{ user.isCurrentUser ? '(you)' : '' }}
          </option>

        </b-select>
      </b-field>
      <b-field>
        <b-radio-button v-model="activeFilter"
                        native-value="isDraft">
          <span>Drafts</span>
        </b-radio-button>
        <b-radio-button v-model="activeFilter"
                        native-value="toBePickedUp">
          <span>Pick-ups</span>
        </b-radio-button>
        <b-radio-button v-model="activeFilter"
                        native-value="inTransit">
          <span>In Transit</span>
        </b-radio-button>
        <b-radio-button v-model="activeFilter"

                        native-value="isShipperApprovalPending">
          <span>Pending Approval</span>
        </b-radio-button>
        <b-radio-button v-model="activeFilter"
                        native-value="isInProgress">
          <span>All active jobs</span>
        </b-radio-button>

        <b-radio-button v-model="activeFilter"

                        native-value="isComplete">
          <span>Completed Jobs</span>
        </b-radio-button>
      </b-field>

      <button class="button is-success"
              v-show="canApprove"
              :class="{ 'is-loading': isCompletingReview }"
              :disabled="!selectedJobIds.length"
              @click="approveSelected"
              type="button">
        Approve ({{selectedJobIds.length}})
      </button>

    </section>

    <template v-if="isLoadingTransactions">
      <font-awesome-icon icon="spinner" spin />  Getting list of transactions.
    </template>
    <template v-else>
      <transactions-table :is-selectable="canApprove" @selectionChange="handleSelectedRow" :company-jobs="visibleTransactions" />
    </template>

  </div>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex'
import TransactionsTable from '@/components/TransactionsTable'

export default {
  name: 'ShipperTransactionsDashboard',

  created() {
    this.fetchTransactions()
  },

  data() {
    return {
      selectedJobIds: [],
      isCompletingReview: false,
      isLoading: false,
      isLoadingTransactions: false
    }
  },

  computed: {
    ...mapGetters('companyJobs', [
      'isInProgress',
      'isDraft',
      'toBePickedUp',
      'isShipperApprovalPending',
      'inTransit',
      'droppedOff',
      'isComplete',
      'lastGpsEntry'
    ]),
    ...mapGetters('company', ['companyUsers']),
    ...mapState(['activeShipperDashboardCategory', 'filterDashboardByUser']),

    visibleTransactions() {
      return this[this.activeFilter]
    },

    canApprove() {
      return this.activeFilter === 'isShipperApprovalPending'
    },

    filterByUser: {
      set(accountKey) {
        this.setFilterByUser(accountKey)
      },
      get() {
        return this.filterDashboardByUser
      }
    },

    activeFilter: {
      get() {
        return this.activeShipperDashboardCategory
      },
      set(filterCategory) {
        this.setActiveCategory(filterCategory)
      }
    },

    /**
     * Array of Google Map Markers, only for the latest GPS locations tho
     * @returns {*}
     */
    markers() {
      const jobKeysToMap = this.visibleTransactions.map((transaction) => transaction.companyJobKey)

      return jobKeysToMap.map((key) => {
        return {
          position: this.lastGpsEntry(key),
          icon: '/map-marker-blue-dot.png'
        }
      })
    }
  },

  components: {
    TransactionsTable
  },

  methods: {
    ...mapActions('companyJobs', {
      fetchTransactionList: 'fetch',
      completeShipperReview: 'completeShipperReview'
    }),
    ...mapMutations({
      setActiveCategory: 'SET_ACTIVE_SHIPPER_DASHBOARD_CATEGORY',
      setFilterByUser: 'SET_FILTER_BY_USER'
    }),

    async fetchTransactions() {
      try {
        this.isLoadingTransactions = true
        await this.fetchTransactionList()
      } catch (error) {
        console.log('Unable to fetch new transaction list')
      } finally {
        this.isLoadingTransactions = false
      }
    },

    async approveSelected() {
      this.isCompletingReview = true
      try {
        await this.completeShipperReview({ isApproved: true, companyJobKeys: this.selectedJobIds })
        this.selectedJobIds = []
        this.fetchTransactions()
      } catch (error) {
        console.log('Error saving companyJob shipper review', error)
      } finally {
        this.isCompletingReview = false
      }
    },

    handleSelectedRow(selection) {
      this.selectedJobIds = [...selection]
    }
  },

  watch: {
    filterByUser: 'fetchTransactions'
  }
}
</script>

<style lang="scss">
.dashboard {
  .field.is-horizontal .field-label {
    display: block;
    flex: 0;
    white-space: nowrap;
  }
}
</style>
<style scoped lang="scss">
.table-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
  height: 450px;
}

.meta-data {
  td {
    border-width: 0;
    font-size: 0.8rem;
  }
}

.approval-wrapper {
  width: 200px;
  margin-top: 15px;
}
</style>
